import {
    CellFormatterService,
    TableOptions,
    FormatterOptions
} from '../common/datatable';
import { AuditModifiedFieldComponent } from './audit-modified-fields/audit-modified-field.component';
import { AuditClassFactory } from './audit-class-maker';

export class AuditProtocolsSamplesGroupsTableOptions {

    options: TableOptions;

    constructor(
        private cellFormatterService: CellFormatterService
    ) {
        this.options = this.getDefaultOptions();
    }

    getDefaultOptions(): TableOptions {

        return {
            csvFileName: 'protocolsSamplesGroups-audit.csv',
            enableDetailColumn: false,
            enableDraggable: false,
            enableSelectable: false,
            enableAuditColumns: false,
            columns: [
                {
                    displayName: 'Type',
                    field: 'UpdateType',
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Modified Fields',
                    field: 'ModifiedFields',
                    sortField: 'ModifiedFields',
                    rendererComponent: AuditModifiedFieldComponent,
                    exportFormatter: this.cellFormatterService.auditModifiedFieldsExportFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Date',
                    field: 'ModifiedDate',
                    formatter: this.cellFormatterService.dateTimeUTCFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Modified By',
                    field: 'ModifiedBy',
                    formatter: this.cellFormatterService.userNameFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Protocol',
                    field: 'ProtocolName',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('ProtocolName', 'ProtocolName'),
                    cellClass: AuditClassFactory.createCellClass('protocolname'),
                },
                {
                    displayName: 'Task Name',
                    field: 'TaskAlias',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('TaskAlias', 'TaskAlias'),
                    cellClass: AuditClassFactory.createCellClass('taskalias'),
                },
                {
                    displayName: 'Sample Number',
                    field: 'SampleNumber',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('SampleNumber', 'SampleNumber'),
                    cellClass: AuditClassFactory.createCellClass('samplenumber'),
                },
                {
                    displayName: 'Sample Type',
                    field: 'SampleType',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('SampleType', 'SampleType'),
                    cellClass: AuditClassFactory.createCellClass('sampletype'),
                },
                {
                    displayName: 'Sample Status',
                    field: 'SampleStatus',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('SampleStatus', 'SampleStatus'),
                    cellClass: AuditClassFactory.createCellClass('samplestatus'),
                },
                {
                    displayName: 'Sample Preservation',
                    field: 'SamplePreservation',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('SamplePreservation', 'SamplePreservation'),
                    cellClass: AuditClassFactory.createCellClass('samplepreservation'),
                },
                {
                    displayName: 'Sample Container',
                    field: 'SampleContainer',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('SampleContainer', 'SampleContainer'),
                    cellClass: AuditClassFactory.createCellClass('samplecontainer'),
                },
                {
                    displayName: 'Special Instructions',
                    field: 'SpecialInstructions',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('SpecialInstructions', 'SpecialInstructions'),
                    cellClass: AuditClassFactory.createCellClass('specialinstructions'),
                },
                {
                    displayName: 'Created By',
                    field: 'CreatedBy',
                    formatter: this.cellFormatterService.userNameFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Created Date',
                    field: 'DateCreated',
                    formatter: this.cellFormatterService.dateTimeUTCFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                }
            ]
        };
    }
}
